// unseenMessagesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const unseenMessagesSlice = createSlice({
  name: 'unseenMessages',
  initialState: {
    unseenCount: 0,
    newUnreadMessage:false,
  },
  reducers: {
    setUnseenCount(state, action) {
      state.unseenCount = action.payload;
    },
    setNewUnreadMessage(state, action) { 
      state.newUnreadMessage = action.payload; 
    },
  },
});

const lastMessageSlice = createSlice({ // eslint-disable-line
  name: "lastMessage",
  initialState: {
    newUnreadMessage: false,
  },
  reducers: {
    setNewUnreadMessage(state, action) {
      state.newUnreadMessage = action.payload;
    },
  },
});
export const { setUnseenCount,setNewUnreadMessage} = unseenMessagesSlice.actions;
export default unseenMessagesSlice;
